/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { LocalStorageService } from './local-storage';
import { HttpAPIService } from './httpAPIservice';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ApiService extends HttpAPIService {
    private wordpressUrl: string = environment.wordpressUrl;
    private apiUrl: string = environment.clientService;

    public endpoints = {
        authenticate: this.apiUrl +  '/auth',
        users: this.apiUrl + '/users',
        divisions: this.apiUrl + '/divisions',
        ropingFormats: this.apiUrl + '/ropingformats',
        organizations: this.apiUrl + '/organizations',
        rodeos: this.apiUrl + '/rodeos',
        wcra: this.apiUrl + '/wcra',
        rodeoEvents: this.apiUrl + '/rodeoEvents',
        notifications: this.apiUrl + '/api/register',
        manage: this.apiUrl + '/manage',
        memberships: this.apiUrl + '/memberships',
        entries: this.apiUrl + '/rodeoRegistrations',
        horses: this.apiUrl + '/horses',
        images: this.apiUrl + '/images',
        videos: this.apiUrl + '/videos',
        settings: this.apiUrl + '/settings',
        runs: this.apiUrl + '/rodeoEventRuns',
        payment: this.apiUrl + '/payment',
        photo: this.apiUrl + '/photo',
        search: this.apiUrl + '/search',
        timer: this.apiUrl + '/timer',
        nominations: this.apiUrl + '/nominations',
        judges: this.apiUrl + '/judges',
        subscriptions: this.apiUrl + '/subscriptions',
        streaming: this.apiUrl + '/streaming',
        versions: this.apiUrl + '/versions',
        requests: this.apiUrl + '/changeRequest',
        documents: this.apiUrl + '/documents',
        wordpress: this.wordpressUrl,
        nominationPoints: this.apiUrl + '/nominationpoints',
    };

    constructor(http: HttpClient, localStorage: LocalStorageService) {
        super(http, localStorage);
    }
}
